module.exports = __webpack_public_path__ + "static/title-contact.74d25ef8.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/title-contact.png
// module id = 314
// module chunks = 2